export enum PLAID_ACTION_TYPES {
  PLAID_TOKEN = 'PLAID_TOKEN',
  LINK_ACCOUNTS = 'LINK_ACCOUNTS',
}
